import makeStyles from "utils/makeStyles";

export default makeStyles(theme => ({
    deleteButton: {
        borderColor: theme.palette.danger.main,
        color: theme.palette.danger.main,
        "&:hover": {
        }
    }
}));